export default {
  title: 'Ei, tem certeza que não quer mais receber nossos e-mails?',
  subtitle:
    'Dá uma olhadinha nos nossos conteúdos e selecione o que você prefere receber:',
  save: 'Salvar configurações',
  goToSite: 'Ir para o site',
  success: 'Informações alteradas com sucesso',
  error: 'Algo deu errado, por favor tente novamente',
  warning: 'Sua alteração pode levar alguns dias para ser processada. Durante esse período, você ainda poderá receber comunicações via email ou notificação.',

  system: {
    title: 'Notificações sociais',
    subtitle: '(solicitações de amizade, etc)',
  },

  marketing: {
    title: 'Conteúdo astrológico e novidades',
    subtitle: '(fases da lua, promoções, previsões mensais, etc)',
  },

  horoscope: {
    title: 'Horóscopo personalizado',
    subtitle: '(novos trânsitos, céu do momento, dicas da semana, etc)',
  },

  footer: {
    home: 'Início',
    help: 'Ajuda',
    contact: 'Fale Conosco',
    useTerms: 'Termos de Uso',
    about: 'Sobre o Astrolink',
    provacy: 'Política de Privacidade',
  },
};
